export default __webpack_public_path__ + "static/media/Add.ea17574d.svg";